const castArray = (value) => (Array.isArray(value) ? value : [value]);

export default castArray;
